import React from 'react';

import { VideoLibrary } from '@/components/common/libraries';

type VideoProps = {
  lessonId?: number;
  programId: number;
};

const Videos = ({ lessonId, programId }: VideoProps) => (
  <VideoLibrary
    lessonId={lessonId}
    programId={programId}
  />
);

export default Videos;
